import {
  COMBINED_RESULTS_LOADED,
  COMBINED_ENTRY_PAGE_LOADED,
  DETAILS_PANEL_LOADED,
  COMBINED_RESULTS_FLIGHTS_ITINERARIES_RENDERED,
  HOMEPAGE_LOADED,
  HOMEPAGE_FALLBACK_AD_LOADED,
  FLIGHTS_DAYVIEW_RENDERED,
  CONFIG_SCREEN_LANDING,
  BOOKING_PANEL_LOADED,
} from '@web-platform/shared-universal-constants/src/redux/actions/render';

import type {
  BookingPanelLoadedAction,
  ConfigScreenLandingAction,
  FlightsDayViewRenderedAction,
} from '@web-platform/shared-universal-types/src/redux/acorn/actions/actions-acorn-types';
import type {
  CombinedEntryPageLoadedAction,
  CombinedResultsFlightsItinerariesRenderedAction,
  CombinedResultsLoadedAction,
  DetailsPanelLoadedAction,
  HomepageFallbackAdLoadedAction,
  HomepageLoadedAction,
} from '@web-platform/shared-universal-types/src/redux/banana/actions/actions-banana-types';
import type { DetailsPanelLoadEventGUIDs } from '@web-platform/shared-universal-types/src/redux/state/appInitial/user/trustedFunnel';
import type { ItinerariesRenderBatch } from '@web-platform/shared-universal-types/src/redux/state/entities/flights/itineraries';
import type { SearchID } from '@web-platform/shared-universal-types-tracking/src/funnelEvents/funnelEventsTypes';
import type { ID, Nullable, Maybe } from '@web-platform/shared-universal-types-utils/src/utils';

export function combinedResultsFlightsItinerariesRendered(
  batch: ItinerariesRenderBatch,
  searchResultsPageGuid?: Nullable<string>,
): CombinedResultsFlightsItinerariesRenderedAction {
  return {
    type: COMBINED_RESULTS_FLIGHTS_ITINERARIES_RENDERED,
    payload: {
      batch,
      searchResultsPageGuid,
    },
  };
}
export function combinedEntryPageLoaded(
  previousScreenName: string,
  eventGuid: string,
): CombinedEntryPageLoadedAction {
  return {
    type: COMBINED_ENTRY_PAGE_LOADED,
    payload: {
      viewGuid: eventGuid,
      searchEventGuid: eventGuid,
      requestId: eventGuid,
      previousScreenName,
    },
  };
}
export function combinedResultsLoaded(
  viewReferrerId: string,
  previousScreenName: string,
  eventGuid: string,
): CombinedResultsLoadedAction {
  return {
    type: COMBINED_RESULTS_LOADED,
    payload: {
      viewGuid: eventGuid,
      searchEventGuid: eventGuid,
      requestId: eventGuid,
      viewReferrerId,
      previousScreenName,
    },
  };
}
export function homepageLoaded(
  viewReferrerId: string,
  previousScreenName: string,
  eventGuid: string,
): HomepageLoadedAction {
  return {
    type: HOMEPAGE_LOADED,
    payload: {
      viewGuid: eventGuid,
    },
  };
}

export function homepageFallbackAdLoaded(): HomepageFallbackAdLoadedAction {
  return {
    type: HOMEPAGE_FALLBACK_AD_LOADED,
  };
}

export function detailsPanelLoaded(
  eventGUIDs: DetailsPanelLoadEventGUIDs,
): DetailsPanelLoadedAction {
  return {
    type: DETAILS_PANEL_LOADED,
    payload: {
      viewGuid: eventGUIDs.viewGuid,
      searchResultsPageGuid: eventGUIDs.searchResultsPageGuid,
      searchResultsOptionGuid: eventGUIDs.searchResultsOptionGuid,
      searchResultSelectedGuid: eventGUIDs.searchResultSelectedGuid,
    },
  };
}
export function flightsDayViewRendered(
  searchId: SearchID,
  viewId: Nullable<string>,
): FlightsDayViewRenderedAction {
  return {
    type: FLIGHTS_DAYVIEW_RENDERED,
    payload: {
      searchId,
      viewId,
    },
  };
}
export function configScreenLanding(
  configPageId: ID,
  itineraryId: Maybe<ID>,
  viewId: Nullable<string>,
  searchResultsPageGuid?: Nullable<string>,
): ConfigScreenLandingAction {
  return {
    type: CONFIG_SCREEN_LANDING,
    payload: {
      configPageId,
      itineraryId,
      viewId,
      searchResultsPageGuid,
    },
  };
}
export function bookingPanelLoaded(searchId: SearchID): BookingPanelLoadedAction {
  return {
    type: BOOKING_PANEL_LOADED,
    payload: {
      searchId,
    },
  };
}
